import React, { useState } from 'react';
import Filter from "./Filter.jsx";
import GridUsuarios from './Grid.jsx';
import EditUsuarioModal from '@components/Modals/Admin/UsuarioEditModal/Index.jsx';

function FiltroUsuarios({ state, setData, deleteItem, updateItem }) {
  const NomeForm = "Filtro de Usuários";
  const [selectedRow, setSelectedRow] = useState(null);

  const [visible, setVisible] = useState(false);

  const openModal = () => setVisible(true);
  const closeModal = () => setVisible(false);

  const [filters, setFilters] = useState({
    numeroSolicitacao: "",
    nomeUnidadeGerencia: "",
    nome: "",
    perfil: ""
  });

  return (
    <div className="row mt-4">
      <div className="col-12 col-md-12">
        <div className="block h-auto">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 col-md-6 d-flex align-items-center">
                <i className="fa-solid fa-filter filter-icon"></i>
                <h2 className="mb-0 p-2">{NomeForm}</h2>
              </div>

              <div className="col-12 col-md-6 d-flex align-items-center justify-content-end">
                <button className="btn btn-menu">
                  <i className="fa-solid fa-bars"></i>
                </button>
              </div>

              <Filter setFilters={setFilters} />

              <EditUsuarioModal
                onUpdate={updateItem}
                visible={visible}
                closeModal={closeModal}
                selectedRow={selectedRow}
              />

              <GridUsuarios
                state={state}
                setData={setData}
                filters={filters}
                onDelete={deleteItem}
                openModal={openModal}
                setSelectedRow={setSelectedRow}
              />

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FiltroUsuarios;